import { all } from 'redux-saga/effects';
import notificationsSaga from './notifications';

export default function* notificationsModuleSaga() {
  yield all([notificationsSaga()]);
}
